import "./LinkedinSubscription.scss"

import { Filter, FilterPosition, FilterVariant, RadioButtonGroup } from "@skylead/component-library"
import classNames from "classnames"
import React, { useState } from "react"
import { useSelector } from "react-redux"

import linkedinSubscriptionConstants from "../../../constants/linkedin-subscriptions"
import { useGlobalTranslation } from "../../../utils/hook"
import { hasPermission, PERMISSIONS } from "../../../utils/team-management/team-management-utils"
import LangText from "../../atoms/LangText"

const LinkedinSubscription = ({
  onChange,
  explanation = false,
  wrapperClassName,
  isConnectLinkedin,
}) => {
  const { tt } = useGlobalTranslation()
  const { LINKEDIN_SUBSCRIPTIONS } = linkedinSubscriptionConstants(tt)
  const [isOpen, setIsOpen] = useState(false)

  const { linkedinSubscription = 1, modalDataShow } = useSelector(state => ({
    linkedinSubscription: state.forms.formData["linkedin-subscription"],
    modalDataShow: state.app.modalData.show,
  }))

  const linkedinSubscriptionWrapperClassname = classNames("linkedin-subscription-wrapper", {
    [wrapperClassName]: wrapperClassName,
  })

  const linkedinSubscriptionMenuClassName = classNames("linkedin-subscription-menu", {
    "modal-menu": modalDataShow,
  })

  const curentLinkedinSubscription = LINKEDIN_SUBSCRIPTIONS.find(
    sub => sub.value === linkedinSubscription,
  )

  return (
    <div className={linkedinSubscriptionWrapperClassname}>
      {isConnectLinkedin ? (
        <div className="linkedin-subscription-setting">
          <div className="name-and-description">
            <span className="large">
              <LangText langKey="linkedin.subscription.select-subscription.label" />
            </span>
            <span className="small">
              <LangText langKey="linkedin.subscription.select-subscription.msg" />
            </span>
          </div>
          <div className="control">
            {LINKEDIN_SUBSCRIPTIONS.map(subscription => {
              return (
                <RadioButtonGroup
                  checked={curentLinkedinSubscription.name === subscription.name}
                  name="linkedin-subscription"
                  onChange={() => onChange(subscription.value)}
                  label={subscription.name}
                />
              )
            })}
          </div>
        </div>
      ) : (
        <div className="linkedin-subscription">
          {explanation && (
            <div className="linkedin-subscription-explanation">
              <span className="large">
                <LangText langKey="subscription-type" />
              </span>
              <span className="small linkedin-subscription-explanation-description">
                <LangText langKey="select-your-linkedin-subscription" />
              </span>
            </div>
          )}
          <div className="linkedin-subscription-radio-buttons">
            <Filter
              noSearch
              tt={tt}
              variant={FilterVariant.MENU}
              position={FilterPosition.RIGHT_BOTTOM}
              iconOnEnd="chevron-down-20"
              data={LINKEDIN_SUBSCRIPTIONS}
              label={curentLinkedinSubscription.name}
              onSelect={sub => onChange(sub.value)}
              filterSearchPlaceholder={tt("search-campaigns-placeholder")}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              disabled={!hasPermission(PERMISSIONS.LINKEDIN_INTEGRATIONS_EDIT)}
              customStyleMenuFilter={{ width: "428px" }}
              customDropdownMenuClass={linkedinSubscriptionMenuClassName}
              characterTooltipLimit={45}
            />
          </div>
        </div>
      )}
    </div>
  )
}

// LinkedinSubscription.propTypes = {
//   onChange: PropTypes.func.isRequired,
//   explanation: PropTypes.bool,
// }

export default LinkedinSubscription
